/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_UpdateInputs */



/**
* | output |
* | --- |
* | "Update" |
*
* @param {Options_Watermark_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_update = /** @type {((inputs?: Options_Watermark_UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar")
	return /** @type {LocalizedString} */ ("Update")
});